export default __webpack_public_path__ + "static/media/field1.7072d505.jpg";